import {
  ActivityIndicator,
  Dimensions,
  FlatList,
  Modal,
  PixelRatio,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { useQuery } from "@tanstack/react-query";
import Colours from "../../utils/Colours";
import { useState } from "react";
import Create_a_Brand from "./Create_a_Brand";
import TopHeaderComponent from "../aTopHeader/TopHeaderComponent";
import { Image } from "expo-image";
import ManageBrandActivities from "./ManageBrandActivities";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { SafeAreaView } from "react-native-safe-area-context";
import { useNavigation } from "@react-navigation/native";
const { width, height } = Dimensions.get("window");
const dpr = Math.round(PixelRatio.get() || 1);
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;
const VAL_NAME = "dxfdmlk0f";
const MAX_RETRIEZ = 20;

// Function to adjust font size
const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  const newSize = size * scaleFactor;

  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const BussinessPage = () => {
  const [showCreateBrand, setShowCreateBrand] = useState(false);
  const [showManageBrandActivities, setShowManageBrandActivities] = useState(false);
  const [selectedBrandData, setSelectedBrandData] = useState(null);

  const navigation = useNavigation();

  const axiosPrivate = useAxiosPrivate();

  const getBrandData = async () => {
    const response = await axiosPrivate.get("/brandData/brandData");
    return response.data; // MUST return data for React Query
  };

  const {
    data: brandData,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["brandData"],
    queryFn: getBrandData,
  });

  const isHasBrand = brandData?.length > 0;

  const handleCreateBrand = () => {
    setShowCreateBrand(true);
    navigation.navigate("create_a_brand");
  };
  // const handleShowManageBrand = (businessBrands) => {
  //   //console.log("BusinessBrands", businessBrands);
  //   setSelectedBrandData(businessBrands);
  //   setShowManageBrandActivities(true);
  // };

  const handleShowManageBrand = (businessBrand) => {
    //console.log("BusinessBrands", businessBrand);

    // Navigate to the stack screen
    navigation.navigate("manageBrand", {
      selectedBrandData: businessBrand, // pass as params
    });
  };

  // Loading
  if (isLoading) {
    return (
      <View style={{ flex: 1, justifyContent: "flex-start", paddingTop: 20 }}>
        <ActivityIndicator color={Colours.PRIMARY} size="large" />
      </View>
    );
  }

  //Error
  if (isError) {
    return (
      <View style={{ padding: dynamicSpacing(20) }}>
        <Text>Failed to load brands</Text>
      </View>
    );
  }

  return (
    <SafeAreaView style={styles.screenWrapper}>
      <TopHeaderComponent headerText={"My Brands"} hideScreen={() => navigation.goBack()} />
      <ScrollView
        style={styles.componentStyle}
        contentContainerStyle={{ flexGrow: 1, paddingBottom: 100 }}
        showsVerticalScrollIndicator={false}
      >
        {!isHasBrand && (
          <View style={styles.container}>
            <Text
              style={{
                fontSize: dynamicFontSize(16),
                color: Colours.DARKLIGHTGRAY,
                fontFamily: "Sen-Regular",
                marginBottom: dynamicSpacing(20),
                marginTop: dynamicSpacing(5),
              }}
            >
              You do not have a brand on Meeza, proceed to create one now.
            </Text>
            <TouchableOpacity style={styles.bigbutton} onPress={handleCreateBrand}>
              <Text
                style={{
                  fontSize: dynamicFontSize(15),
                  color: Colours.DARKGRAY,
                  fontFamily: "Sen-Bold",
                }}
              >
                Create a brand
              </Text>
            </TouchableOpacity>
          </View>
        )}

        {isHasBrand && (
          <>
            <View style={styles.container}>
              <Text
                style={{
                  fontSize: dynamicFontSize(16),
                  color: Colours.DARKGRAY,
                  fontFamily: "Sen-Regular",
                  marginBottom: dynamicSpacing(20),
                  marginTop: dynamicSpacing(5),
                }}
              >
                My brands
              </Text>
              {/* <FlatList
                data={brandData}
                scrollEnabled={false}
                keyExtractor={(item) => item._id}
                renderItem={({ item }) => (
                  <TouchableOpacity
                    style={styles.showStyle}
                    onPress={() => handleShowManageBrand(item)}
                    delayPressIn={150}
                  > */}
              {brandData?.map((item) => (
                <TouchableOpacity
                  key={item._id}
                  style={styles.showStyle}
                  onPress={() => handleShowManageBrand(item)}
                  delayPressIn={150}
                  activeOpacity={0.7}
                >
                  <Image
                    style={styles.showImage}
                    // source={require("../../../assets/treasure.jpg")}
                    source={{ uri: item.image }}
                  />
                  <Text
                    style={{
                      fontSize: dynamicFontSize(17),
                      color: Colours.DARKGRAY,
                      fontFamily: "Sen-Regular",
                      // marginBottom: dynamicSpacing(15),
                    }}
                  >
                    {item.brandName}
                  </Text>
                </TouchableOpacity>
              ))}
              {/* /> */}
            </View>
            <View style={styles.container}>
              <TouchableOpacity style={styles.bigbutton} onPress={handleCreateBrand}>
                <Text
                  style={{
                    fontSize: dynamicFontSize(15),
                    color: Colours.DARKGRAY,
                    fontFamily: "Sen-Bold",
                  }}
                >
                  Add new brand
                </Text>
              </TouchableOpacity>
            </View>
          </>
        )}
      </ScrollView>
    </SafeAreaView>
  );
};

export default BussinessPage;

const styles = StyleSheet.create({
  screenWrapper: {
    flex: 1,
    backgroundColor: "white", // Guarantees a fully solid opaque canvas base layer
  },
  componentStyle: {
    backgroundColor: Colours.LIGHTEST,
    display: "flex",
    // padding: dynamicSpacing(15),
    height: "100%",
  },
  showImage: {
    width: dynamicSize(60),
    height: dynamicSize(60),
    borderRadius: dynamicSize(30),
  },
  container: {
    display: "flex",
    margin: dynamicSpacing(15),
    padding: dynamicSpacing(10),
    backgroundColor: "white",
    borderRadius: dynamicSize(15),
  },
  bigbutton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: dynamicSpacing(20),
    marginTop: dynamicSpacing(10),
    marginBottom: dynamicSpacing(10),
    backgroundColor: Colours.LIGHTEST,
    borderRadius: dynamicSize(15),
  },
  showStyle: {
    display: "flex",
    flexDirection: "row",
    gap: dynamicSpacing(10),
    alignItems: "center",
    alignContent: "center",
    padding: dynamicSpacing(10),
    marginVertical: dynamicSpacing(5),
    backgroundColor: Colours.PRIMARY_LIGHTER,
    borderRadius: dynamicSize(15),
  },
});
